import React from "react";
import Movies from "./movies";
import "./index.css";

const App = () => {
  return (
    <>
  
      <Movies />
    </>
  );
};

export default App;
